var jQuery = require('jquery');

var Animate = function() {
  this.animationQueue = [];
  this.activeAnimation = null;
};

Animate.prototype = {
  stopAllAnimations: function() {
    this.animationQueue = [];
    if (this.activeAnimation) {
      window.cancelAnimationFrame(this.activeAnimation);
      this.activeAnimation = null;
    }
  },

  scaleAnimation: function(elm, scale, duration) {
    var getTransformProperty = function(element) {
      // Returns null/undefined or a transform string
      return element &&
            element.view &&
            element.view.e &&
            element.view.e.style &&
            element.view.e.style.transform;
    };

    var transformProperty = getTransformProperty(elm);

    if (! window.requestAnimationFrame ||
      (transformProperty === undefined || transformProperty === null)) {
       return this;
    }

    this.animationQueue.push({
      elm: elm,
      scale: scale,
      duration: duration
    });

    if (this.animationQueue.length === 1) {
      this._scaleAnimation(elm, scale, duration);
    }

    return this;
  },

  scrollElementIntoContainerView: function (elm, container) {
    if (this._isElementOutsideView(elm, container)) {
      jQuery(container).animate({
        scrollTop: jQuery(elm).position().top
      }, 500);
    }
  },

  _isElementOutsideView: function (elm, container) {
    var currentScrollPosition = container.scrollTop;
    var totalScrollHeight = currentScrollPosition + container.offsetHeight;
    var elementTopOffset = elm.offsetTop;

    var isOutsideScrollTop = elementTopOffset < currentScrollPosition;
    var isOutsideScrollHeight = elementTopOffset > totalScrollHeight;

    return isOutsideScrollTop || isOutsideScrollHeight;
  },

  _scaleAnimation: function(elm, finalScale, duration) {
    var self = this,
        time,
        initialScale = 1.0,
        scaleRegex = /scale\((-?\d*\.?\d+)\)/,
        element = elm.view.e,
        elmCSS = element.style.transform;

    var matches = elmCSS.match(scaleRegex);

    if (matches && matches.length > 1) {
      initialScale = parseFloat(matches[1]);
    }

    var scaleDelta = finalScale - initialScale;
    var scalingUp = scaleDelta >= 0 ? true : false;

    var animateScale = function(timestamp) {
      var timeDelta = timestamp - (time || timestamp);

      time = timestamp;

      var incrementValue = scaleDelta / (duration / timeDelta);

      initialScale += incrementValue;

      // If initialScale has reached (or exceeded) the final scale, or if there is
      // no duration, set the element to the final scale and load the next animation
      if ((initialScale >= finalScale) && scalingUp ||
          (initialScale <= finalScale) && ! scalingUp ||
          duration === 0) {

        element.style.transform =  'scale(' + finalScale + ')';
        self._stopAndplayNextAnimationInQueue(self.activeAnimation);
      } else {
        element.style.transform =  'scale(' + initialScale + ')';
        self.activeAnimation = window.requestAnimationFrame(animateScale);
      }
    };

    this.activeAnimation = window.requestAnimationFrame(animateScale);
  },

  _stopAndplayNextAnimationInQueue: function(requestID) {
    window.cancelAnimationFrame(requestID);
    this.activeAnimation = null;
    this.animationQueue.shift();

    if (this.animationQueue.length > 0) {
      var animation = this.animationQueue[0];
      this._scaleAnimation(animation.elm, animation.scale, animation.duration);
    }
  },
};

module.exports = Animate;



// WEBPACK FOOTER //
// ./src/ui/animate.js